import { Image, Space } from 'antd';
import React from 'react';
import styled from 'styled-components';
import QmasLogo from 'assets/img/qmas_logo_white_full.png';
import RegisterBg from 'assets/img/register_background.jpg';
import { AButton } from 'components/Antd';
import { nextPath } from 'util/icwUtility';
import { useHistory } from 'react-router-dom';
import { LOGIN_PATH } from 'shared/routes';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 415px;
  padding: 10px 20px;
  min-height: 100vh;
  max-height: 100vh;
  background-image: url(${RegisterBg});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.5;
  background: linear-gradient(
    64deg,
    rgba(135, 140, 215, 0.4) 16.44%,
    rgba(90, 195, 240, 0.4) 94.29%
  );
`;

const Wrapper = styled(Space)`
  flex: 1;
  justify-content: center;
  z-index: 2;
`;

const Title = styled.h3`
  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.4px;
`;

const Description = styled.p`
  width: 315px;
  margin: auto;
  color: var(--Text-Blue-006, #ebedef);
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.28px;
`;

const LoginButton = styled(AButton)`
  width: 180px;
  padding: 14px 30px;
  margin: auto;
  margin-top: 70px;
`;

const AppSiderWithLogin = ({ onClickLogin, showEmpty }) => {
  const history = useHistory();
  const handleClickLogin = () => {
    if (onClickLogin) {
      onClickLogin();
      return;
    }
    nextPath(history)(LOGIN_PATH);
  };
  return (
    <Container>
      <Overlay />
      <Image preview={false} width={100} src={QmasLogo} />
      {showEmpty && (
        <Wrapper direction="vertical">
          <Title>Welcome Back!</Title>
          <Description>If you’re one of us, login with your email or LinkedIn account.</Description>
          <LoginButton onClick={handleClickLogin} ghost>
            Login
          </LoginButton>
        </Wrapper>
      )}
    </Container>
  );
};

export default AppSiderWithLogin;
